import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5df4cb42&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5df4cb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4cb42",
  null
  
)

export default component.exports